import { render, staticRenderFns } from "./FichaExpress.vue?vue&type=template&id=d9702630&"
import script from "./FichaExpress.vue?vue&type=script&lang=js&"
export * from "./FichaExpress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports